const PREFIX = "source-compare-session:v1:";

export function sourceCompareSessionKey(repoId) {
  return `${PREFIX}${repoId || ""}`;
}

export function loadSourceCompareSession(repoId) {
  if (!repoId || typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(sourceCompareSessionKey(repoId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function saveSourceCompareSession(repoId, session) {
  if (!repoId || typeof sessionStorage === "undefined") return;
  try {
    if (!session) {
      sessionStorage.removeItem(sourceCompareSessionKey(repoId));
      return;
    }
    sessionStorage.setItem(sourceCompareSessionKey(repoId), JSON.stringify(session));
  } catch {
    // Ignore quota or private-mode failures; the live panel still works.
  }
}

export function emptySourceCompareSession() {
  return {
    addSource: null,
    selection: { baseSnapshotId: "", headSnapshotId: "" },
    preferredSelection: null,
    compareResult: null,
  };
}
